import '../sass/project.scss';

/* Project specific Javascript goes here. */
import axios from 'axios';

import 'jquery';
import 'bootstrap';

// change default parameters for axios
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// // change default paramsSerializerq
// axios.defaults.paramsSerializer = params => {
//   return Qs.stringify(params, {arrayFormat: 'repeat'});
// };

// change default parameters for axios
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

import { createApp } from 'vue'
import Map from './vue/map.vue';

const vue_app = createApp(Map);
const vue_root_component = vue_app.mount('#vue-app')

window.vue_app = vue_app;
window.vue_root_component = vue_root_component;